export default __webpack_public_path__ + "static/media/thumbs_up.ec4740f7.svg";